document.addEventListener('DOMContentLoaded', function() {

document.getElementById('popup__close').addEventListener('click', function(event) {
    document.getElementById('popup').classList.remove('opened');
    document.getElementById('popup__img').src = '';
    document.getElementById('popup__iframe').innerHTML = '';
});

document.querySelectorAll('.openPopup').forEach(function(button) {
    button.addEventListener('click', function(event) {
        var file = button.getAttribute('data-file');
        document.getElementById('popup__img').src = file;
        document.getElementById('popup').classList.add('opened');
    });
});

document.querySelectorAll('.openPopupPDF').forEach(function(button) {
    button.addEventListener('click', function(event) {
        var file = button.getAttribute('data-file');
        document.getElementById('popup__embed').src = file;
        document.getElementById('popup').classList.add('opened');
    });
});

document.querySelectorAll('.openPopupVideo').forEach(function(button) {
    button.addEventListener('click', function(event) {
        var file = button.getAttribute('data-file');      
        document.getElementById('popup__iframe').innerHTML = file;
        document.getElementById('popup').classList.add('opened');
    });
});

document.querySelectorAll('.popup__content').forEach(function(popup) {
    popup.addEventListener('click', function(e) {
        if (!e.target.closest('.popup__iframe') || !e.target.closest('.popup__img')) {
            document.getElementById('popup').classList.remove('opened');
            document.getElementById('popup__img').src = '';
            document.getElementById('popup__iframe').innerHTML = '';
            document.getElementById('popup__embed').innerHTML = '';
        }
    });
});

// Prevent overlay click when interacting with the inner container
document.querySelectorAll('.popup__content .popup__iframe').forEach(function(content) {
    content.addEventListener('click', function(e) {
        e.stopPropagation();
    });
});
document.querySelectorAll('.popup__content .popup__img').forEach(function(content) {
    content.addEventListener('click', function(e) {
        e.stopPropagation();
    });
});
document.querySelectorAll('.popup__content .popup__embed').forEach(function(content) {
    content.addEventListener('click', function(e) {
        e.stopPropagation();
    });
});


});